import ShareFeedbackModal from "@/Components/UI/Modals/ShareFeedbackModal";
import { PageProps } from "@/types/page";
import { usePage } from "@/utils/turboSafeInertia";
import { PropsWithChildren, useState } from "react";
import { ShareFeedbackContext } from "./ShareFeedbackContext";

export function ShareFeedbackProvider({ children }: PropsWithChildren) {
    const { user } = usePage<PageProps>().props;
    const [showModal, setShowModal] = useState(false);

    const canShareFeedback =
        user?.type === "client" && user.has_payment_setup === true;

    return (
        <ShareFeedbackContext.Provider
            value={{
                canShareFeedback,
                showShareFeedbackModal: () => setShowModal(true),
            }}
        >
            <ShareFeedbackModal
                show={showModal}
                onRequestClose={() => setShowModal(false)}
            />
            {children}
        </ShareFeedbackContext.Provider>
    );
}
